import React from 'react';
import TimeInput from '~/reusable-components/inputs/TimeInput';

const CSS = require('./TimeInput.module.scss');

function TimePicker({ defaultValue }: { defaultValue?: string }) {
  return (
    <div className={CSS.TimeInputContainer}>
      <span className={CSS.StartTimeLabel}>Start time</span>
      <TimeInput defaultValue={defaultValue} />
    </div>
  );
}

export default TimePicker;
